import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ExtraState {
  showAutomationReport: boolean;
}

const initialState: ExtraState = {
  showAutomationReport: false,
};

export const extraSlice = createSlice({
  name: 'extra',
  initialState,
  reducers: {
    setShowAutomationReport: (state, action: PayloadAction<boolean>) => {
      state.showAutomationReport = action.payload;
    },
  },
});

export const {
  setShowAutomationReport,
} = extraSlice.actions;

export default extraSlice.reducer;
